"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdpSliderGripHorz = function AdpSliderGripHorz(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M153.6 4.416h153.6v1024H153.6v-1024zm435.2 1024v-1024H435.2v1024h153.6zm281.6 0v-1024H716.8v1024h153.6z"
  })));
};

AdpSliderGripHorz.defaultProps = {
  viewBox: '0 0 1024 1043.776',
  height: '1em',
  width: '0.9811em'
};
AdpSliderGripHorz.displayName = 'AdpSliderGripHorz';
var _default = AdpSliderGripHorz;
exports.default = _default;